import Link from '../../Components/ui/Link/Link';

import styles from './footer.module.scss';
import Button from '../../Components/ui/Button/Button';
import { Container } from '../../Components/ui/Container/Container';

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <Container className={styles.container}>
                <nav className={styles.nav}>
                    <Button asChild variant="text" style={{ textDecoration: 'none' }}>
                        <Link to="https://spreeai.com/terms-of-service">Terms of Service</Link>
                    </Button>
                    <Button asChild variant="text" style={{ textDecoration: 'none' }}>
                        <Link to="https://spreeai.com/privacy-notice">Privacy Notice</Link>
                    </Button>
                    <Button asChild variant="text" style={{ textDecoration: 'none' }}>
                        <a
                            href="https://drive.google.com/file/d/1TKFElj5GUyqvgtiy0HTExvIccSie3Zu7/view?usp=sharing"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Terms and Conditions
                        </a>
                    </Button>
                </nav>
                <div>
                    <p>© 2023–2025 SpreeAI Corporation. All rights reserved.</p>
                </div>
            </Container>
        </footer>
    );
};
